'use client'
import React from 'react'
import styled from 'styled-components'
import {
    History as UpdatesIcon,
    AutoAwesome as FeatureIcon,
    BugReport as FixIcon,
    Style as UIIcon,
    Language as LanguageIcon,
    Download as DownloadIcon,
    ElectricBolt as PerformanceIcon
} from '@mui/icons-material'

const UpdatesContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    min-height: 100%;
    color: white;
    text-align: center;
    padding: 0px 20px 40px 20px;
    box-sizing: border-box;
    overflow-y: auto;
`;

const TitleSection = styled.div`
    width: 100%;
    max-width: 1100px;
    text-align: left;
    margin-top: 10px;
    margin-bottom: 48px;
    display: flex;
    flex-direction: column;
`;

const MainTitle = styled.h1`
    font-size: 2.5rem;
    font-weight: 800;
    color: white;
    margin: 0;
    margin-bottom: 8px;
    letter-spacing: -1px;
    font-family: 'Chakra Petch', sans-serif;
    text-transform: uppercase;
    
    span {
        color: #7260ff;
        text-shadow: 0 0 10px rgba(114, 96, 255, 0.6);
    }
`;

const MainSubtitle = styled.p`
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.5);
    margin: 0;
    font-weight: 400;
    letter-spacing: 1px;
`;

const Timeline = styled.div`
    position: relative;
    padding-left: 26px;
    flex-direction: column;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 40px;
        bottom: 10px;
        width: 2px;
        background: linear-gradient(to bottom, 
            rgba(99, 102, 241, 0.5) 0%, 
            rgba(168, 85, 247, 0.5) 50%, 
            rgba(99, 102, 241, 0) 100%
        );
    }
`

const UpdateCard = styled.div`
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 20px;
    padding: 20px 30px;
    margin-bottom: 40px;
    position: relative;
    transition: all 0.3s ease;
    flex-direction: column;

    &::before {
        content: '';
        position: absolute;
        left: -36px;
        top: 30px;
        width: 14px;
        height: 14px;
        background: #0d1117;
        border: 3px solid #6366f1;
        border-radius: 50%;
        box-shadow: 0 0 10px rgba(99, 102, 241, 0.5);
        z-index: 2;
    }

    &:hover {
        background: rgba(255, 255, 255, 0.04);
        border-color: rgba(99, 102, 241, 0.2);
        //transform: translateX(5px);
    }
`

const DateTag = styled.div`
    font-family: 'Consolas', monospace;
    font-size: 0.9rem;
    color: #6366f1;
    margin-bottom: 8px;
    font-weight: 600;
    letter-spacing: 1px;
`

const ProjectTitle = styled.h2`
    font-family: 'Chakra Petch', sans-serif;
    font-size: 1.5rem;
    margin: 0 0 20px 0;
    display: flex;
    align-items: center;
    gap: 12px;
    color: #fff;

    span {
        font-size: 0.8rem;
        background: rgba(99, 102, 241, 0.2);
        color: #818cf8;
        padding: 4px 10px;
        border-radius: 20px;
        font-family: 'Inter', sans-serif;
    }
`

const ChangeGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    flex-direction: column;
`

const ChangeItem = styled.div`
    display: flex;
    gap: 15px;
    
    .icon-wrapper {
        color: ${props => props.$color || '#6366f1'};
        display: flex;
        align-items: flex-start;
        padding-top: 2px;
        
        svg {
            font-size: 18px;
        }
    }

    .content {
        flex: 1;
        flex-direction: column;
        
        strong {
            display: block;
            font-size: 0.95rem;
            margin-bottom: 4px;
            color: rgba(255, 255, 255, 0.9);
        }
        
        span {
            font-size: 0.85rem;
            color: rgba(255, 255, 255, 0.5);
            line-height: 1.5;
        }
    }
`

import { useLanguage } from '@/contexts/LanguageContext'

// ... (estilos sin cambios)

const UpdatesView = () => {
    const { t } = useLanguage()

    const UPDATE_DATA = [
        {
            date: '14 JAN, 2026',
            version: '0.3.0',
            title: t('V030_TITLE'),
            changes: [
                {
                    type: 'ui',
                    icon: <UIIcon />,
                    color: '#818cf8',
                    title: t('V030_KEYSELECTOR_TITLE'),
                    desc: t('V030_KEYSELECTOR_DESC')
                },
                {
                    type: 'feature',
                    icon: <FeatureIcon />,
                    color: '#fbbf24',
                    title: t('V030_SIDEBAR_TITLE'),
                    desc: t('V030_SIDEBAR_DESC')
                },
                {
                    type: 'ui',
                    icon: <UIIcon />,
                    color: '#818cf8',
                    title: t('V030_BUYEXPERIENCE_TITLE'),
                    desc: t('V030_BUYEXPERIENCE_DESC')
                }
            ]
        },
        {
            date: '07 JAN, 2026',
            version: '0.2.2',
            title: t('V022_TITLE'),
            changes: [
                {
                    type: 'feature',
                    icon: <FeatureIcon />,
                    color: '#fbbf24',
                    title: t('V022_RADIO_TITLE'),
                    desc: t('V022_RADIO_DESC')
                },
                {
                    type: 'feature',
                    icon: <DownloadIcon />,
                    color: '#22c55e',
                    title: t('V022_EXPORT_TITLE'),
                    desc: t('V022_EXPORT_DESC')
                },
                {
                    type: 'lang',
                    icon: <LanguageIcon />,
                    color: '#34d399',
                    title: t('V022_LANG_TITLE'),
                    desc: t('V022_LANG_DESC')
                }
            ]
        },
        {
            date: '30 DEC, 2025',
            version: '0.2.0',
            title: t('V020_TITLE'),
            changes: [
                {
                    type: 'feature',
                    icon: <PerformanceIcon />,
                    color: '#ec4899',
                    title: t('V020_ELECTRON_TITLE'),
                    desc: t('V020_ELECTRON_DESC')
                },
                {
                    type: 'feature',
                    icon: <FeatureIcon />,
                    color: '#fbbf24',
                    title: t('V020_CLOUD_TITLE'),
                    desc: t('V020_CLOUD_DESC')
                },
                {
                    type: 'ui',
                    icon: <UIIcon />,
                    color: '#818cf8',
                    title: t('V020_PREVIEWS_TITLE'),
                    desc: t('V020_PREVIEWS_DESC')
                }
            ]
        },
        {
            date: '22 DEC, 2025',
            version: '0.1.2',
            title: t('V012_TITLE'),
            changes: [
                {
                    type: 'feature',
                    icon: <FeatureIcon />,
                    color: '#fbbf24',
                    title: t('V012_GALLERY_TITLE'),
                    desc: t('V012_GALLERY_DESC')
                },
                {
                    type: 'ui',
                    icon: <UIIcon />,
                    color: '#818cf8',
                    title: t('V012_HUD_TITLE'),
                    desc: t('V012_HUD_DESC')
                }
            ]
        },
        {
            date: '15 DEC, 2025',
            version: '0.1.0',
            title: t('V010_TITLE'),
            changes: [
                {
                    type: 'feature',
                    icon: <PerformanceIcon />,
                    color: '#ec4899',
                    title: t('V010_ENGINE_TITLE'),
                    desc: t('V010_ENGINE_DESC')
                },
                {
                    type: 'lang',
                    icon: <LanguageIcon />,
                    color: '#34d399',
                    title: t('V010_LANG_TITLE'),
                    desc: t('V010_LANG_DESC')
                }
            ]
        },
        {
            date: 'SEP 2, 2024',
            isOrigin: true,
            title: t('V_ORIGIN_TITLE'),
            subtitle: t('V_ORIGIN_SUBTITLE'),
            desc: t('V_ORIGIN_DESC')
        }
    ]

    return (
        <UpdatesContainer>
            <TitleSection>
                <MainTitle><span>Up</span>dates</MainTitle>
                <MainSubtitle>{t('UPDATES_SUBTITLE')}</MainSubtitle>
            </TitleSection>

            <Timeline>
                {UPDATE_DATA.map((update, idx) => (
                    <UpdateCard
                        key={idx}
                        style={update.isOrigin ? {
                            border: '1px solid rgba(99, 102, 241, 0.3)',
                            background: 'rgba(99, 102, 241, 0.03)',
                            boxShadow: '0 0 30px rgba(99, 102, 241, 0.05)'
                        } : {}}
                    >
                        <DateTag>{update.date}</DateTag>
                        <ProjectTitle>
                            {update.title}
                            {update.version && <span>{update.version}</span>}
                        </ProjectTitle>

                        {update.isOrigin ? (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <strong style={{ color: '#818cf8', fontSize: '1rem' }}>{update.subtitle}</strong>
                                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem', lineHeight: '1.6' }}>{update.desc}</span>
                            </div>
                        ) : (
                            <ChangeGroup>
                                {update.changes.map((change, cIdx) => (
                                    <ChangeItem key={cIdx} $color={change.color}>
                                        <div className="icon-wrapper">
                                            {change.icon}
                                        </div>
                                        <div className="content">
                                            <strong>{change.title}</strong>
                                            <span>{change.desc}</span>
                                        </div>
                                    </ChangeItem>
                                ))}
                            </ChangeGroup>
                        )}
                    </UpdateCard>
                ))}
            </Timeline>
        </UpdatesContainer>
    )
}

export default UpdatesView
